<div class="container-margin">
  <div class="page-caption">
    <h1 style="color: #0074a7" class="page-title" translate>
      components.avisoLegal.1
    </h1>
  </div>

  <div id="" class="page-wrapper">
    <div class="page-content">
      <div
        id="post-1146"
        class="post-1146 page type-page status-publish hentry"
      >
        <div class="entry-content">
          <p>&nbsp;</p>
          <ol>
            <li><strong translate>components.avisoLegal.2</strong></li>
          </ol>
          <p translate>
            components.avisoLegal.3
            <a href="https://inviertispro.com/">www.inviertispro.com</a>
            components.avisoLegal.4
            <span>inversioninmobiliaria.inviertispro.com</span>
            components.avisoLegal.5
            <a href="mailto:info@inviertispro.com">info&#64;inviertispro.com</a> .
          </p>
          <ol start="2">
            <li><strong translate>components.avisoLegal.7</strong></li>
          </ol>
          <p translate>components.avisoLegal.8</p>
          <p translate>components.avisoLegal.9</p>
          <p translate>components.avisoLegal.10</p>
          <p translate>components.avisoLegal.11</p>
          <p translate>components.avisoLegal.12</p>
          <p translate>components.avisoLegal.13</p>
          <ol start="4">
            <li><strong translate>components.avisoLegal.14</strong></li>
          </ol>
          <p translate>components.avisoLegal.15</p>
          <p translate>components.avisoLegal.16</p>
          <ol start="5">
            <li><strong translate>components.avisoLegal.17</strong></li>
          </ol>
          <p translate>components.avisoLegal.18</p>
          <p translate>components.avisoLegal.19</p>
          <ol start="6">
            <li><strong translate>components.avisoLegal.20</strong></li>
          </ol>
          <p translate>components.avisoLegal.21</p>
          <ol start="7">
            <li><strong translate>components.avisoLegal.22</strong></li>
          </ol>
          <p translate>components.avisoLegal.23</p>
          <ol start="8">
            <li><strong translate>components.avisoLegal.24</strong></li>
          </ol>
          <p translate>
            components.avisoLegal.25<br />
            components.avisoLegal.27
          </p>
          <p translate>components.avisoLegal.28</p>
          <ol start="9">
            <li><strong translate>components.avisoLegal.29</strong></li>
          </ol>
          <p translate>components.avisoLegal.30</p>
          <ol start="10">
            <li><strong translate>components.avisoLegal.31</strong></li>
          </ol>
          <p translate>components.avisoLegal.32</p>
          <ol start="11">
            <li><strong translate>components.avisoLegal.33</strong></li>
          </ol>
          <p translate>components.avisoLegal.34</p>
          <p translate>components.avisoLegal.35</p>
          <ol start="12">
            <li><strong translate>components.avisoLegal.36</strong></li>
          </ol>
          <p translate>components.avisoLegal.37</p>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</div>
